import createTableSelectionStore from "ds/components/Table/store/useTableSelectionStore";

const useFlowsProjectRolesTableSelectionStore = createTableSelectionStore();

export default useFlowsProjectRolesTableSelectionStore;
